import { FormControl, Validators } from '@angular/forms';
import { EoFormPanelConfig, EoInputConfig } from 'ngx-eo-web-components';

export const forgotPwdSubmitLabel = 'Επαναφορά κωδικού';

export const forgotPasswordFormConfig: EoFormPanelConfig[] = [
  new EoFormPanelConfig({
    name: 'request',
    panelContentStyleClass: 'grid',
    config: [
      // new EoInputConfig({
      //   name: 'username',
      //   label: 'Όνομα χρήστη',
      //   type: 'text',
      //   styleClass: 'col-12',
      //   control: new FormControl('', Validators.required),
      //   errors: { required: 'Το όνομα χρήστη είναι υποχρεωτικό' },
      // }),
      new EoInputConfig({
        name: 'email',
        label: 'Email',
        type: 'email',
        styleClass: 'col-12',
        control: new FormControl('', [
          Validators.required,
          Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i),
        ]),
        errors: {
          required: 'Το email είναι υποχρεωτικό',
          pattern: 'Μη έγκυρη διεύθυνση email',
        },
      }),
    ],
  }),
];
